<template>
  <div>
    <contenful-apis
      url="spaces/uhuxxitrg1zr/entries"
      :params="{ content_type: 'evenement', include: 3, order:'fields.dateStarted','fields.dateStarted[gte]': now }"
      :key-path="['evenements']"
    />
    <contenful-apis
      url="spaces/uhuxxitrg1zr/entries"
      :params="{ content_type: 'article', include: 3, order:'-fields.publishedDate', select: 'fields.title,fields.preview,fields.coverImg,fields.preview,fields.slug,fields.publishedDate,fields.authors,fields.youtubeVideoId' }"
      :key-path="['articles']"
    />
    <picture-intro :data="data"/>
    <!--<vuex-api-hoc key-path="articles">-->
    <event-article-preview />
    <who-are-we :data="data"/>
    <our-values :data="data"/>
    <our-actions :data="data"/>
    <newsletter/>
  </div>
</template>
<style scoped>
.box {
  height: 100%;
}
</style>
<script>
import { actions, getApiData } from "vuex-api";
import { mapState } from "vuex";
import PictureIntro from "./picture-intro.vue";
import WhoAreWe from "./who-are-we.vue";
import OurValues from "./values";
import OurActions from "./our-actions";
import Newsletter from "./newsletter";
import EventArticlePreview from "./EventArticlePreview";
import moment from "moment";

export default {
  components: {
    EventArticlePreview,
    Newsletter,
    OurActions,
    OurValues,
    WhoAreWe,
    PictureIntro
  },
  name: "HomeContainer",
  created: function() {
    this.$store.dispatch(actions.request, {
      requestConfig: {
        baseURL: "https://cdn.contentful.com",
        headers: {
          Authorization:
            "Bearer a668f1bb4d9f2c93e9f6f4dfa8954ea8a1ae452c1a1cfb354293df81f08895e9"
        }
      },
      method: "GET",
      url: "spaces/uhuxxitrg1zr/entries",
      params: { content_type: "homePage", include: 3 },
      keyPath: ["homePage"] // Will set the namespace where it will be stored in the vuex state
    });
  },
  computed: mapState({
    data: getApiData("homePage")
  }),
  data() {
    return {
      now: moment().format()
    };
  }
};
</script>
